import { render, staticRenderFns } from "./Lnb.vue?vue&type=template&id=56f05af5&scoped=true&"
import script from "./Lnb.vue?vue&type=script&lang=ts&"
export * from "./Lnb.vue?vue&type=script&lang=ts&"
import style0 from "./Lnb.vue?vue&type=style&index=0&id=56f05af5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f05af5",
  null
  
)

export default component.exports